/* eslint-disable no-alert */
import React, { useContext } from 'react';
import AppStateContext from '../../../context/appStateContext';
import useTextCorrection from '../../../../hooks/useTextCorrection';

import { CardBody, CardCtn } from './index.style';

interface CardProps {
  BillTo: string;
  CustomerName: string;
  CustomerCode: string;
  TerritoryCode: any;
}

const Card: React.FC<CardProps> = ({ BillTo, CustomerName, CustomerCode, TerritoryCode }): React.ReactElement => {
  const { selectedCustomerId, setAppStateDetails } = useContext(AppStateContext);
  const { titleCase } = useTextCorrection();

  const setCustomer = () => {
    setAppStateDetails({ selectedCustomerId: CustomerCode, serviceCentreCode: TerritoryCode });
    return;
  };

  return (
    <CardCtn>
      <CardBody
        active={selectedCustomerId === CustomerCode}
        type="button"
        onClick={(e): void => {
          e.preventDefault();
          setCustomer();
        }}
      >
        <span>{titleCase(CustomerName)}</span>
      </CardBody>
    </CardCtn>
  );
};

export default Card;
